import { MessageHeaderWrapper } from "./MessageHeader.style";
import { ChatHeader } from "./ChatHeader";
import { IMessageListFilter } from "@home-health-notify/domain";
import { IChatAccess } from "hhn-commons";

const MessageHeader = ({
  chatAccess,
  showSearch,
  setShowSearch,
  onFilter,
  isMemberFlag,
  isChatLoading,
}: {
  chatAccess: IChatAccess;
  showSearch: boolean;
  setShowSearch: () => void;
  onFilter: (filters: IMessageListFilter) => void;
  isMemberFlag: boolean;
  isChatLoading: boolean;
}) => {
  return (
    <MessageHeaderWrapper>
      <ChatHeader
        chatType={chatAccess.getChatType()}
        info={chatAccess.chatInfo}
        showSearch={showSearch}
        setShowSearch={setShowSearch}
        onFilter={onFilter}
        isMemberFlag={isMemberFlag}
        isChatLoading={isChatLoading}
      />
    </MessageHeaderWrapper>
  );
};

export default MessageHeader;
